import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Skeleton } from "@mui/material";
import SurveyResponseRatingCard from "../../../../components/SurveyReportCard/SurveyResponseRatingCard";

const BreakdownSection = ({
    reportData,
    appliedFilters,
    loading
}) => {
    const { t } = useTranslation();
    const breakdownKeys = ["technicianArrival", "equipmentCondition", "technicianService"];

    return (
        <Grid container spacing={2} sx={{ mt: 1 }}>
            {loading ? (
                <>
                    <Grid item xs={12} md={4}>
                        <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2 }} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2 }} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2 }} />
                    </Grid>
                </>
            ) : (
                reportData?.questionBreakdown?.length > 0 ? (
                    (() => {
                        const orderType = appliedFilters.orderType;
                        
                        if (orderType === "Pickup") {
                            const q = reportData.questionBreakdown.find(
                                (x) => x.feedbackQuestionId === 27
                            );
                            if (!q) return null;

                            return (
                                <Grid item xs={12} md={4}>
                                    <SurveyResponseRatingCard
                                        title={t("reports.patientSurveyReportPage.breakdown.technicianArrival")}
                                        description={t(
                                            "reports.patientSurveyReportPage.breakdown.description.technicianArrivalPickup"
                                        )}
                                        yesPct={Math.round((q.yesPct ?? 0) * 100)}
                                        noPct={Math.round((q.noPct ?? 0) * 100)}
                                    />
                                </Grid>
                            );
                        }
                        
                        if (orderType === "Delivery") {
                            return reportData.questionBreakdown.map((q, index) => {
                                const key = breakdownKeys[index];

                                const title = t(`reports.patientSurveyReportPage.breakdown.${key}`);

                                const description =
                                    key === "technicianArrival"
                                        ? t(
                                            "reports.patientSurveyReportPage.breakdown.description.technicianArrivalDelivery"
                                        )
                                        : t(
                                            `reports.patientSurveyReportPage.breakdown.description.${key}`
                                        );

                                return (
                                    <Grid item xs={12} md={4} key={q.feedbackQuestionId ?? index}>
                                        <SurveyResponseRatingCard
                                            title={title}
                                            description={description}
                                            yesPct={Math.round((q.yesPct ?? 0) * 100)}
                                            noPct={Math.round((q.noPct ?? 0) * 100)}
                                        />
                                    </Grid>
                                );
                            });
                        }
                        
                        return reportData.questionBreakdown.map((q, index) => (
                            <Grid item xs={12} md={4} key={q.feedbackQuestionId ?? index}>
                                <SurveyResponseRatingCard
                                    title={t(
                                        `reports.patientSurveyReportPage.breakdown.${breakdownKeys[index]}`
                                    )}
                                    description={t(
                                        `reports.patientSurveyReportPage.breakdown.description.${breakdownKeys[index]}`
                                    )}
                                    yesPct={Math.round((q.yesPct ?? 0) * 100)}
                                    noPct={Math.round((q.noPct ?? 0) * 100)}
                                />
                            </Grid>
                        ));
                    })()
                ) : null
            )}
        </Grid>
    );
};

export default BreakdownSection;
